import { Form, FormInstance } from 'antd';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { FORMAT_TIME } from '../../const';
import { RootState } from '../../store';
import { ItemTaskType } from '../../types';
import { defaultDataConfig } from '../data/defaultDataConfig';

const useTypeInitializer = (form: FormInstance<ItemTaskType>) => {
    const values = Form.useWatch([], form);
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);
    const [isFirstEditing, setIsFirstEditing] = useState<boolean>(false);
    const [previousTask, setPreviousTask] = useState<ItemTaskType>();
    const [previousTaskType, setPreviousTaskType] = useState<number>();

    useEffect(() => {
        if (values?.number && !previousTaskType && !values?.type && !isFirstEditing) {
            setIsFirstEditing(true);
        }
    }, [values]);

    useEffect(() => {
        if (!currentTask) {
            setIsFirstEditing(false);
        }

        if (currentTask && currentTask?.id !== previousTask?.id) {
            setIsFirstEditing(false);
            setPreviousTask(currentTask);
            setPreviousTaskType(undefined);
        }
    }, [currentTask]);

    useEffect(() => {
        if (isFirstEditing && currentTask && values?.type && values?.type !== previousTaskType && defaultDataConfig) {
            setPreviousTaskType(values?.type);

            const startTime = defaultDataConfig[values?.type!].defaultStartTime;

            const endTime = DateTime.fromSQL(startTime)
                .plus({
                    minutes: defaultDataConfig[values?.type!].defaultDuration,
                })
                .toFormat(FORMAT_TIME);

            form.setFieldsValue({
                ...values,
                start_datetime: dayjs(startTime, 'HH:mm') as any,
                end_datetime: dayjs(endTime, 'HH:mm') as any,
                priority: defaultDataConfig[values?.type!].priority,
                // should uncomment after adding fields to Task entity
                // show_busy: defaultDataConfig[values?.type!].showBusy,
                // reminder: defaultDataConfig[values?.type!].reminder,
                // icon_id: defaultDataConfig[values?.type!].iconId,
            });
        }
    }, [isFirstEditing, values]);

    return { isFirstEditing };
};

export default useTypeInitializer;
